<div class="w-p-100 h-p-100 flex flex-row flex-1-0-auto">
  <div class="news-widget-container h-p-100 p-t-30 scroll full-grow-no-shrink-no-basis  ">
    <particle-shimmer-loader
      [elemCount]="1"
      [elemWidth]="375"
      [elemHeight]="500"
      [elemPadding]="10"
      [elemMargin]="10"
      [isVisible]="!dataLoaded"
    ></particle-shimmer-loader>
    <div *ngIf="hasData && dataLoaded" class="p-l-30 p-r-30 w-p-100 h-p-100">
      <div class="blue-box-container">
        <span>Note:</span> Displaying worldwide tax news for {{actualNewsDate | date :'longDate'}}
      </div>

      <mat-accordion class="custom-accordion">
        <mat-expansion-panel id="{{categoryIds[i]}}" [expanded]="i === currentExpandedItemIndex"
                             *ngFor="let category of newsItems.newsCategories; let i = index;"
                             (opened)="expanded(categoryIds[i])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{category.title}}
            </mat-panel-title>
            <mat-panel-description>
              ({{category.newsCount}})
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div *ngFor="let countryNews of category.countryNews" class="accordion-news-conent">
            <h1 class="title">
              {{countryNews.title}}
            </h1>
            <div *ngFor="let newsItem of countryNews.newsItems" class="flex flex-col">
              <h1 class="sub-title flex flex-row flex-wrap justify-between items-start">
                {{newsItem.newsHeading}}
                <!--<button
                        mat-button
                        class="orbitax-flat-button"
                        particleAnalytics
                        analyticsCategory= "tax-news-widget"
                        [analyticsAction]= ""
                        analyticsName="">
                  <mat-icon>create</mat-icon>
                  <span>Edit Incorporation</span>
                </button>-->
              </h1>
              <div class="content-container">
                <div [innerHtml]="newsItem.newsContent"></div>
                <div class="flex flex-row flex-wrap">
                  <div *ngIf="newsItem.relatedTools.length > 0" class="flex flex-row itrce-news-links-container m-r-15">
                    <a (click)="onClickRelatedTools(newsItem.relatedTools)" class="related-tool-title">
                      Related Tools
                    </a>
                    <span>:</span>
                    <div class="links flex flex-row flex-wrap">
                      <a *ngFor="let relatedTool of newsItem.relatedTools"
                         particleAnalytics
                         analyticsCategory="taxnews-item"
                         analyticsAction="related-tools-links"
                         [analyticsName]="relatedTool.title"
                         href="{{relatedTool.url}}" target="_blank" rel="noopener noreferrer" class="link-color"
                         matTooltip="{{relatedTool.title}}">
                        <span>{{relatedTool.title}}</span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="newsItem.incorporationTag && newsItem.incorporationTag!=''"
                       class="itrce-news-links-container flex flex-row">
                    <div class="italic">
                      Status:
                    </div>
                    <div class="links flex flex-row flex-wrap" matTooltip="{{
            (newsItem.categoryId===1 && newsItem.incorporationTag==='ITRCE') ? (itrceApprovedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===1 && newsItem.incorporationTag==='CR') ? (crApprovedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===1 && newsItem.incorporationTag==='READ') ? (readApprovedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)

            : (newsItem.categoryId===2 && newsItem.incorporationTag==='ITRCE') ? (itrceProposedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===2 && newsItem.incorporationTag==='CR') ? (crProposedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===2 && newsItem.incorporationTag==='READ') ? (readProposedTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)

            : (newsItem.categoryId===3 && newsItem.incorporationTag==='ITRCE') ? (itrceTreatyTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===3 && newsItem.incorporationTag==='CR') ? (crTreatyTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)
            : (newsItem.categoryId===3 && newsItem.incorporationTag==='READ') ? (readTreatyTooltipText|taxnewsIncorporationTooltipFormat:newsItem.incorporationDate)

            : ''
            }}">
                      <a class="link-color flex flex-row">
                        <span>Incorporated</span>
                        <span *ngIf="newsItem.incorporationTag==='ITRCE'">&nbsp;- ITRCE and CR</span>
                        <span *ngIf="newsItem.incorporationTag==='CR'">&nbsp;- CR</span>
                        <span *ngIf="newsItem.incorporationTag==='READ'">&nbsp;- Read</span>
                        <mat-icon>done_all</mat-icon>
                      </a>
                    </div>
                  </div>
                  <div class="flex flex-row itrce-news-links-container">
                    <div class="italic">
                      Date:&nbsp;
                    </div>
                    <div class="italic flex flex-row flex-wrap">
                      {{newsItem.updateDate|taxnewsDateFormat}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div *ngIf="!hasData && dataLoaded" class="empty-content flex flex-col flex-1-0-100">
      <div class="text-container">
        <img
          src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
          alt="Empty images">
        <h1>No news found</h1>
        <div class="text">We couldn't find any news for your chosen period and settings. Try adjusting the date
          range, types and country selections.
        </div>
      </div>
    </div>
  </div>
  <div class="page-separator"></div>
  <div class=" full-grow-no-shrink-no-basis  scroll m-t-30 flex flex-col justify-start items-start">
    <div class="hide-message flex flex-row justify-end items-center">
      <!--<a href="#">
        Hide this message
      </a>-->
    </div>
    <div class="map-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis  ">
      <particle-dashboard-hitmap></particle-dashboard-hitmap>
      <!--<img  src="http://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/OrbitaxDashboard-maps.png" class="world-map" alt="Word Map">-->
    </div>
  </div>
</div>
